/**
 * 🎗️ The keepsakes (v6.54, per Javi): a relic and a trained skill that
 * do NOTHING, left by a friend. They are the thread of the homage
 * chains - four hidden achievements, each a way of winning at
 * Ascension 8+ that nobody does by accident, each to unlock a creature
 * in a playtester's honour (the creatures are Javi's to draw; the
 * chain ends pay a title until then).
 *
 * How they reach a run: once `keepsake-relic` / `keepsake-lesson` are
 * in the ledger (Ascension 10 cleared plus every elite modifier survived /
 * every boss felled), startNewRun stamps `run.keepsakes`. The FIRST
 * relic offer of that run - the draft's starting-bonus pick, in
 * practice - carries the relic as a FOURTH card, and the first Training
 * Grounds carries the lesson as a fourth option; `run.keepsakeOffered`
 * makes sure it is once per run. Never in the weekly or the daily:
 * their shared skeleton must not shift. Both are hidden from every
 * roll, shop and codex list until met.
 */
export const KEEPSAKE_RELIC = 'relic-keepsake'
export const KEEPSAKE_SKILL = 'keepsake-lesson'
